import { useEffect } from 'react';

import { FormikProps } from 'formik';
import { isEqual, pick } from 'lodash';

import { AppDetailFormFormikModel } from '../../models/app-detail-form-formik.model';

export const useSyncFormikValuesWithExternalState = (
  iconId: number | null,
  screenshotsIds: number[],
  formik: FormikProps<AppDetailFormFormikModel>
) => {
  useEffect(() => {
    const newValues = { iconId, screenshotsIds };
    if (
      !isEqual(newValues, pick(formik.values, ['iconId', 'screenshotsIds']))
    ) {
      formik.setValues(prev => ({ ...prev, ...newValues }));
    }
  }, [iconId, screenshotsIds]);
};
